import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, withKeys as _withKeys, vModelText as _vModelText, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7bb3983b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "a-formField has-quickSearch" }
const _hoisted_2 = ["for"]
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = { class: "a-hidden" }
const _hoisted_5 = ["id", "name"]
const _hoisted_6 = {
  class: "m-quickSearch",
  ref: "quickSearchDropdown"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "m-quickSearch__item" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, ")", -1))
const _hoisted_13 = { class: "m-quickSearch__item" }
const _hoisted_14 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconComponent = _resolveComponent("IconComponent")!
  const _directive_debounce = _resolveDirective("debounce")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.label && _ctx.placeholderState)
          ? (_openBlock(), _createElementBlock("label", {
              key: 0,
              class: "a-formField__placeholder",
              for: _ctx.name
            }, _toDisplayString(_ctx.label), 9, _hoisted_2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("button", {
      class: "a-formField__action a-button -simple",
      type: "submit",
      "aria-label": _ctx.searchTranslation,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleSubmit()))
    }, [
      _createVNode(_component_IconComponent, {
        "icon-id": _ctx.getIconName,
        "data-qa": _ctx.SearchQASelectors.SEARCH_ICON
      }, null, 8, ["icon-id", "data-qa"]),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.searchTranslation), 1)
    ], 8, _hoisted_3),
    _withDirectives(_createElementVNode("input", {
      class: _normalizeClass(['a-formInput', { hasSuggestions: _ctx.showQuickSearch }]),
      type: "text",
      ref: "searchInput",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.placeholderState = false)),
      onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.placeholderState = _ctx.value === '')),
      onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.handleSubmit()), ["enter"])),
      onFocusin: _cache[4] || (_cache[4] = ($event: any) => (_ctx.hideQuickSearch = false)),
      id: _ctx.name,
      name: _ctx.name,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.value) = $event)),
      autocomplete: "off",
      "data-js": "artists-search-input"
    }, null, 42, _hoisted_5), [
      [_directive_debounce, _ctx.handleInput, "300"],
      [_vModelText, _ctx.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_6, [
      (_ctx.suggestion)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.suggestion, (s) => {
            return (_openBlock(), _createElementBlock("ul", { key: s }, [
              _createElementVNode("li", {
                class: "m-quickSearch__item -suggestion",
                onClick: ($event: any) => (_ctx.handleQuickSearchSubmit(s))
              }, [
                _createVNode(_component_IconComponent, {
                  "icon-id": _ctx.iconName.Search
                }, null, 8, ["icon-id"]),
                _createTextVNode(),
                _createElementVNode("span", null, _toDisplayString(s), 1)
              ], 8, _hoisted_7)
            ]))
          }), 128))
        : _createCommentVNode("", true),
      (_ctx.quickSearchList)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.quickSearchList.slice(0, 3), (item) => {
            return (_openBlock(), _createElementBlock("ul", {
              key: item.title
            }, [
              _createElementVNode("li", _hoisted_8, [
                _createElementVNode("a", {
                  href: _ctx.addSearchTermToUrl(item.url ?? '')
                }, [
                  _createVNode(_component_IconComponent, {
                    "icon-id": _ctx.iconName.Calendar
                  }, null, 8, ["icon-id"]),
                  _createElementVNode("span", null, _toDisplayString(item.title), 1),
                  (item.events)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, ", " + _toDisplayString(_ctx.getCities(item.events)), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", null, "(" + _toDisplayString(_ctx.earliestStartDateNumeric(item.events ?? [])), 1),
                  (
                                    _ctx.hasDateSpan(
                                        _ctx.earliestStartDateNumeric(item.events ?? []),
                                        _ctx.latestEndDateNumeric(item.events ?? [])
                                    )
                                )
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, " - " + _toDisplayString(_ctx.latestEndDateNumeric(item.events ?? [])), 1))
                    : _createCommentVNode("", true),
                  _hoisted_12
                ], 8, _hoisted_9)
              ])
            ]))
          }), 128))
        : _createCommentVNode("", true),
      (_ctx.quickSearchArtistsList)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.quickSearchArtistsList.slice(0, 3), (item) => {
            return (_openBlock(), _createElementBlock("ul", {
              key: item.title
            }, [
              _createElementVNode("li", _hoisted_13, [
                _createElementVNode("a", {
                  href: _ctx.addSearchTermToUrl(item.url ?? '')
                }, [
                  _createVNode(_component_IconComponent, {
                    "icon-id": _ctx.iconName.Calendar
                  }, null, 8, ["icon-id"]),
                  _createElementVNode("span", null, _toDisplayString(item.title), 1)
                ], 8, _hoisted_14)
              ])
            ]))
          }), 128))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, _ctx.showQuickSearch]
    ])
  ]))
}